import React, { Suspense, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import _ from 'lodash';
import { Panel } from 'react-bootstrap';
import withAuthentication from '../../hoc/withAuthentication';
import withLayout from '../../hoc/withLayout';

import { useAlertStore } from '../../store/providers/Alert';
import { useCommunicationGroupStore } from '../../store/providers/CommunicationGroup';
import Permission from '../../components/Permission/Permission';
import { breadcrumbAddRoute, breadcrumbRemoveRoute } from '../../store/actions/breadcrumb';
import Spinner from '../../components/Spinner/Spinner';

import * as constants from '../../constants';
import { columns, sorting } from './CommunicationGroupsListSchema';
import DocumentSetupList from '../../components/Lists/DocumentSetupList/DocumentSetupList';
const SideMenu = React.lazy(() => import('../../components/SideMenu/SideMenu'));
const PageHeader = React.lazy(() => import('../../components/PageHeader/PageHeader'));
const CommunicationGroupModal = React.lazy(() => import('../../components/Modals/CommunicationGroup/CommunicationGroupModal'));

function CommunicationGroups() {
    const dispatch = useDispatch();
    const { addAlert } = useAlertStore();
    const { selectRecord, listRecords, newRecord, deleteRecord, data, clearData } = useCommunicationGroupStore();

    const [isMounted, setIsMounted] = useState(false);
    const [isBusy, setIsBusy] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [listData, setListData] = useState([]);

    const pagePermission = constants.PERMISSION_CONTENT_COMMUNICATIONGROUPS;
    const [hasPermission, setHasPermission] = useState(false);
    const [canEdit, setCanEdit] = useState(false);

    const selectedHandler = (communicationGroup) => {
        setIsEditing(true);
        selectRecord({ communicationGroupId: communicationGroup.id });
    };

    const addedHandler = () => {
        setIsEditing(true);
        newRecord();
    };

    const cancelledHandler = () => {
        setIsEditing(false);
    };

    const submittedHandler = () => {
        setIsEditing(false);
        listRecords();
    };

    const deletedHandler = (communicationGroup) => {
        deleteRecord({ communicationGroupId: communicationGroup.id });
    };

    const refreshedHandler = () => {
        listRecords();
    };

    useEffect(() => {
        if (!_.isEmpty(data)) {

            if (data.status === 'fail' || data.status === 'error') {
                addAlert({ key: constants.ALERT_SERVER_ERROR, text: <strong>{data.body}</strong>, type: constants.ALERT_TYPE_DANGER });
                clearData();
            }

            if (data.scope === 'delete' && data.status === 'success') {
                listRecords();
            }

            if (data.status === 'success' && data.scope === 'list') {
                setListData(data.body);
            }

            setIsBusy(data.status === 'processing' && (data.scope === 'delete' || data.scope === 'list'));
        }
    }, [data, addAlert, clearData, listRecords]);


    useEffect(() => {
        if (!hasPermission) { return; }
        if (isMounted) { return; }
        dispatch(breadcrumbAddRoute({ key: 'communicationGroups', parent: 'Content', text: 'Communication Groups', path: '/communicationGroups' }));
        listRecords();

        setIsMounted(true);
    }, [isMounted, hasPermission, listRecords, dispatch]);

    useEffect(() => {
        return () => {
            dispatch(breadcrumbRemoveRoute());
        };
    }, [dispatch]);

    return (
        <>
            <SideMenu activeKey="content" />
            <div className="content-body">
                <Permission showDenied={true} pagePermission={pagePermission} hasPermission={hasPermission} setHasPermission={setHasPermission} setCanEdit={setCanEdit} />
                {hasPermission && isMounted &&
                    <Suspense fallback={<Spinner text="Loading..." />}>
                        {
                            isEditing && <CommunicationGroupModal
                                show={isEditing}
                                canEdit={canEdit}
                                title={(!_.isEmpty(data) && !_.isEmpty(data.body)) ? 'Edit Communication Group' : 'Add Communication Group'}
                                cancelled={() => cancelledHandler()}
                                submitted={() => submittedHandler()} />
                        }
                        <div style={{ paddingRight: '15px' }}>
                            <PageHeader title="Communication Groups" />
                            <Panel>
                                <Panel.Body>
                                    <DocumentSetupList
                                        compType="Communication Groups"
                                        listData={listData}
                                        isBusy={isBusy}
                                        sorting={sorting}
                                        columns={columns}
                                        hideCopy={true}
                                        hidePrint={true}
                                        hideFilter={true}
                                        permissionEdit={canEdit}
                                        added={() => addedHandler()}
                                        selected={(group) => selectedHandler(group)}
                                        deleted={(group) => deletedHandler(group)}
                                        refreshed={() => refreshedHandler()} />
                                </Panel.Body>
                            </Panel>
                        </div>
                    </Suspense>
                }
            </div>
        </>
    );
}
export default withAuthentication(withLayout(CommunicationGroups));





